(ns practitest.frontend.components.datepicker
  (:require
    [tick.core :as tick]
    [clojure.string :as str]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.components.datepicker2 :as datepicker2]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(defn- as-instant
  "instant from an instant or an ISO string with or without a zone offset."
  [value]
  (when value
    (if (tick/instant? value)
      value
      (let [trimmed (str/trim (str value))]
        (when-not (str/blank? trimmed)
          (try
            (tick/instant (tick/zoned-date-time trimmed))
            (catch js/Error _ nil)))))))

(defn instant-picker
  "Point in time.
  
  `value` is an instant or ISO string
  The field shows wall-clock time in the user's PT timezone (browser timezone as fallback).
  
  `on-change` receives an instant, or nil when cleared."
  [{:keys [on-change class field-id value disabled?] :as _props}]
  (let [user-timezone @(re-frame/subscribe [::subs/current-user-timezone])
        zone (if user-timezone (tick/zone user-timezone) (tick/zone))
        zoned (some-> (as-instant value) (tick/in zone))
        local->instant (fn [local-dt]
                         (-> local-dt
                             (.atZone zone)
                             (tick/instant)))]
    [datepicker2/native-picker-input
     {:native-type "datetime-local"
      :native-value (when zoned
                      (tick/format datepicker2/native-date-time-formatter zoned))
      :on-native-change (fn [s]
                          (on-change (some-> (datepicker2/parse-native-date-time-value s)
                                             (local->instant))))
      :display-value (when zoned
                       (tick/format fu/date-time-formatter zoned))
      :parse-text (fn [s]
                    (some-> (datepicker2/parse-typed-date-time s)
                            (local->instant)))
      :placeholder datepicker2/date-time-placeholder
      :on-change on-change
      :class class
      :id field-id
      :disabled? disabled?}]))

(defn time-picker
  [{:keys [on-change
           class
           field-id
           value
           disabled?]
    :as   _props}]
  (let [formatter (tick/formatter :iso-local-time)
        value* (if (tick/time? value)
                 (tick/format formatter value)
                 value)]
    [:input
     {:class     class
      :type      "time"
      :id        field-id
      :value     value*
      :disabled  disabled?
      :on-change (fn [e]
                   (let [timestr (dom/event-value e)
                         ;; uses current browser timezone by default
                         time (when-not (str/blank? timestr)
                                (tick/time timestr))]
                     (when on-change
                       (on-change time))))}]))
